export default function Terms() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Terms & Conditions</h2>
      <p>Terms & Conditions – Nawabi Bites

By using our website, you agree to the following terms:

Use of Website

Users must provide accurate information while ordering.

You agree not to misuse or attempt to damage the website.

Product Information

We ensure accurate product details, but minor variations may occur.

Payments

All payments are final and processed through secure gateways.

Limitation of Liability

Nawabi Bites is not liable for:

Delivery delays caused by courier

Customer-provided incorrect addresses

Allergic reactions (ingredients are mentioned clearly)

Changes to Policy

Policies may be updated anytime without prior notice.</p>
    </div>
  );
}
